<script setup lang="ts">

import {ArrowRight, Mail} from "@lucide/vue";
import ReferralRequestDialog from "@/core/components/referral/ReferralRequestDialog.vue";
</script>

<template>
  <ReferralRequestDialog type="hospital">
    <button
      type="button"
      class="group flex w-full items-center justify-between gap-3 my-1 px-4 py-3 rounded-lg bg-white hover:bg-gray-700 text-sm text-primary text-left"
    >
      <div class="flex items-center gap-3">
        <div class="flex size-8 shrink-0 items-center justify-center rounded-full bg-muted">
          <Mail class="size-4" />
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-medium leading-tight">Votre centre hospitalier n'apparait pas dans la liste ?</span>
          <span class="text-xs leading-tight">Cliquez ici pour le référencer sur Apodis</span>
        </div>
      </div>
      <ArrowRight class="size-4 shrink-0" />
    </button>
  </ReferralRequestDialog>
</template>

<style scoped>

</style>
